import React from 'react';
import DashboardTabs from '@components/common/Dashboard/DashboardTabs';
import { TabWrapper } from './styled';
// eslint-disable-next-line react/display-name
export default (props) => {
  const { currentShareId } = props;

  let pageType = -1;
  if (props.pageType) {
    pageType = props.pageType;
  }

  return (
    <TabWrapper>
      <DashboardTabs
        pageType={pageType}
        id={currentShareId}
      />
    </TabWrapper>
  );
};
